<template>
	<div class="chat-view">
		<ChatSidebar />
		<ChatContent />
	</div>
</template>

<script>
import ChatSidebar from "@/console-new/components/help/chat/ChatSidebar.vue";
import ChatContent from "@/console-new/components/help/chat/ChatContent.vue";
import {useOpenAIChatsStore, useUserStore} from "@/console-new/stores";

export default {
	setup() {
		let openAIChatsStore = useOpenAIChatsStore();
		let userStore = useUserStore();
		return { openAIChatsStore, userStore };
	},
	name: "ChatView",
	components: {ChatSidebar, ChatContent},
	methods: {
		fetchChats() {
			if(this.userStore.currBusinessId) {
				this.openAIChatsStore.getChats();
			}
		},
	},
	mounted() {
		this.fetchChats();
	},
	beforeUnmount() {
		if(this.openAIChatsStore.activeChatId) {
			this.openAIChatsStore.unsubscribeFromChat(this.openAIChatsStore.activeChatId);
			this.openAIChatsStore.activeChatId = null;
		}
	},
	watch: {
		'userStore.currBusinessId': function (newVal, oldVal) {
			if (newVal !== oldVal) {
				this.fetchChats();
			}
		},
		'openAIChatsStore.activeChatId': function (newVal, oldVal) {
			if(oldVal && oldVal !== 'new') {
				this.openAIChatsStore.unsubscribeFromChat(oldVal);
			}
			if(newVal && newVal !== 'new') {
				this.openAIChatsStore.subscribeToChat(newVal);
			}
		},
	}
}
</script>

<style scoped lang="scss">
	.chat-view {
		padding: 0;
		position: relative;
		display: flex;
		border-radius: 13px;
		background-color: var(--color-bg);
		box-shadow: 0 3px 5px var(--color-box-shadow-3);
		width: 100%;
		overflow: hidden;
		height: calc(100vh - ((var(--main-padding) * 2 ) + 60px));
		min-height: 450px;
		@media screen and (max-width: 768px) {
			height: calc(100vh - ((var(--main-padding) * 2 ) + 100px));
		}
	}
</style>